import React from "react";
import { useState, useEffect } from "react";
import * as apiUtility from "../../config/APIUtils";
import {
    Box,
    Grid,
    Paper,
    Typography,
    Dialog,
    DialogTitle,
    DialogContent,
    IconButton,
    Button,
    DialogActions
} from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import { Chip, Table } from "@mui/joy";
import { useUser } from "../../config/UserContext";
import { PolicyPdfReport } from "../ReportGenerationComponents/PolicyPdfReport";
import { CoursePdfReport } from '../ReportGenerationComponents/CoursePdfReport';
import {coursePdfReport} from '../ReportGenerationComponents/tempCoursePdfReport'
import { BsFiletypePdf } from "react-icons/bs";

export default function CourseReviewComponent({ open, onClose, courseData, history}) {

    // const { userData, roleDetail, homeDetail } = useUser();
    const [trainingProviders, setTrainingProviders] = React.useState([]);
    
    var userDetails = {};
        useEffect(() => {
               var apiRequest = apiUtility.apiInputRequest;
               apiRequest.endPoint = "course/fetch-all-training-providers";
               apiUtility.fetchAPIDataGET(apiRequest).then(res => {
                   setTrainingProviders(res.data)
               }).catch((error) => console.error(error));
           }, []);

    const handleDownloadPDF = async () => {
        // let userDetails = userData;
       
        userDetails["homeName"] = courseData.home_id;
        userDetails["roleName"] = courseData.roleName;
        userDetails["firstName"] = courseData.firstName;
        userDetails["lastName"] = courseData.lastName;
        userDetails["user_id"] = courseData.user_id;
        userDetails["dob"] = courseData.dob;
        userDetails["title"] = courseData.title;

        
        await coursePdfReport(userDetails, history.courseData,courseData,trainingProviders, "Course history report", "Course History", "Course History");
        //  await CoursePdfReport(userDetails, history.courseData, {}, "crsReport", "crsReport", true);
        //console.log("resp--->",resp);
        
     //   await PolicyPdfReport(userDetails, history.courseData, 'Course History', 'Carepassport_PolicyHistory_' + courseData.courseData.id + "_" + courseData?.user_id, false);
    };
    function formatDateOnly(dateString) {
  // Clean the AM/PM part
  const cleaned = dateString.replace(/\./g, '').toUpperCase();

  const date = new Date(cleaned);

  if (isNaN(date)) return "Invalid date";

  // Return only dd/mm/yyyy
  return date.toLocaleDateString('en-GB'); 
}


    return (
        <>
            <Dialog
                open={open}
                onClose={onClose}
                maxWidth="lg"
                fullWidth
                disableScrollLock={true}
                PaperProps={{ sx: { borderRadius: 3, p: 1 } }}
            >
                <DialogTitle variant="body1">Course History</DialogTitle>
                <DialogContent dividers>
                    <Grid container spacing={3}>
                        <Grid item xs={12} md={4}>
                            <Typography variant="h6" gutterBottom>
                            </Typography>

                            <Box sx={{ mt: 2 }}>
                                {[
                                    { label: "Title", value: courseData?.title },
                                    // { label: "Type", value: courseData.type },
                                    // { label: "Description", value: courseData.description },
                                    { label: "User ID", value: courseData?.user_id },
                                    { label: "Home ", value: courseData?.home_id },
                                    { label: "Role ", value: courseData?.roleName },

                                ].map((field, index) => (
                                    <Box
                                        key={field.label}
                                        sx={{
                                            display: 'flex',
                                            alignItems: 'start',
                                            mb: 2,
                                            "&:last-child": { mb: 0 }
                                        }}
                                    >
                                        <Typography
                                            variant="body2"
                                            color="primary"
                                            sx={{
                                                minWidth: '120px',
                                                pt: 0.5
                                            }}
                                        >
                                            {field.label}:
                                        </Typography>
                                        <Typography variant="body2">
                                            {field.value || "N/A"}
                                        </Typography>
                                    </Box>
                                ))}
                            </Box>

                        </Grid>

                        <Grid item xs={12} md={8}>

                            <Typography variant="h6">
                                History

                                <IconButton color="primary" title="Download Course History" onClick={handleDownloadPDF} sx={{ p: '8px' }} aria-label="directions">
                                <BsFiletypePdf />
                            </IconButton>
                               
                                    {/* <IconButton
                                        color="primary"
                                        onClick={handleDownloadPDF}
                                        title="Download Course History"
                                    >
                                        <DownloadIcon />
                                    </IconButton> */}
                          
                            </Typography>
                            <Box sx={{ mt: 2 }}>

                                <Table
                                    borderAxis="bothBetween"
                                    stripe="odd"
                                    hoverRow
                                    sx={{ minWidth: 700 }}
                                >
                                    <thead>
                                        <tr>
                                            <th>Course Code</th>
                                            <th>Version</th>
                                            <th>Training Provider</th>
                                            <th>Date</th>
                                            <th>Expiry Date</th>
                                            <th>Status</th>

                                        </tr>
                                    </thead>
                                    <tbody>
                                        {(history.courseData?.length > 0) ?
                                            history.courseData.map((row) => (
                                                // <tr key={row._id}>
                                                //     <td>{row.course_id}</td>
                                                //     <td>{row.tp_course_code}</td>
                                                //     <td>
                                                //         {new Date(row.completion_date).toLocaleDateString()}
                                                //     </td>
                                                //     <td>
                                                //         {(row.expiry_date != "") ? new Date(row.expiry_date).toLocaleDateString() : "N/A"}
                                                //     </td>
                                                   
                                                //     <td>
                                                //         <Chip
                                                //             color={row.verification === "Validated" ? "success" : "warning"}
                                                //             variant="soft"
                                                //             size="sm"
                                                //         >
                                                //             {row.verification}
                                                //         </Chip>
                                                //     </td>

                                                // </tr>
                                                 <tr key={row._id}>
                                                <td>{row.course_id}</td>
                                                <td>{row.courseVersion.tp_course_code}</td>
                                                <td>{(trainingProviders.find(item=>item.tp_id==parseInt(row.courseVersion.training_provider_id)).provider_name)}</td>
                                                <td>
                                                    {formatDateOnly(row.completion_date)}
                                                </td>
                                                <td>
                                                    {(row.expiry_date != "") ? new Date(row.expiry_date).toLocaleDateString() : "N/A"}
                                                </td>
                                                <td>
                                                    <Chip
                                                        color={row.verification === "Validated" ? "success" : (row.verification === "Expired") ? "danger" : "warning"}
                                                        variant="soft"
                                                        size="sm"
                                                    >
                                                        {row.verification}
                                                    </Chip>
                                                </td>

                                            </tr>
                                            ))
                                            : <td colSpan={5} style={{ "text-align": "center" }}>No history available</td>
                                        }
                                    </tbody>
                                </Table>
                            </Box>

                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button onClick={onClose}>Close</Button>
                </DialogActions>
            </Dialog>

        </>
    );
}
